import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

// TODO
// const loadView = (viewName) => {
//   // route level code-splitting
//   // this generates a separate chunk (about.[hash].js) for this route
//   // which is lazy-loaded when the route is visited.
//   import(/* webpackChunkName: "about" */ `../views/${viewName}.vue`);
// };

const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeView.vue"),
  },
  {
    path: "/log-in",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/LoginView.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/RegisterView.vue"),
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ChangePasswordView.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ResetPasswordView.vue"),
  },
  {
    path: "/users/:userId/profile",
    name: "UserProfile",
    props: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/UserProfileView.vue"),
  },
  {
    path: "/bookmaker-leagues",
    name: "BookmakerLeagues",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/BookmakerLeaguesView.vue"
      ),
    // TODO zrobić jako children
    // children: [
    //   {
    //     path: ":leagueId/rank",
    //     name: "BookmakerLeague",
    //     props: true,
    //     component: () =>
    //       import(
    //         /* webpackChunkName: "about" */ "../views/BookmakerLeagueView.vue"
    //       ),
    //   },
    // ],
  },
  {
    path: "/bookmaker-leagues/:leagueId/rank",
    name: "BookmakerLeague",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/BookmakerLeagueView.vue"
      ),
  },
  {
    path: "/bookmaker-leagues/:leagueId/user/:userId/bets",
    name: "SpecificUserBets",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/SpecificUserBetsView.vue"
      ),
  },
  {
    path: "/bookmaker-bets",
    name: "BookmakerBets",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/BookmakerBetsView.vue"),
  },
  {
    path: "/instruction",
    name: "Instruction",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/InstructionView.vue"),
  },
  {
    path: "/admin",
    name: "AdminPanel",
    meta: { admin: true },
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/AdminPanelView.vue"),
  },
  {
    path: "/admin/users",
    name: "AdminUsers",
    meta: { admin: true },
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/AdminUsersView.vue"),
  },
  {
    path: "/admin/users/:userId/bets",
    name: "AdminUserBets",
    props: true,
    meta: { admin: true },
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/AdminUserBetsView.vue"),
  },
  {
    path: "/admin/matches",
    name: "AdminMatches",
    meta: { admin: true },
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/AdminMatchesView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const isAuthorized = store.getters["user/isAuthorized"];
  if (
    to.name !== "AuthError" &&
    to.name !== "Login" &&
    to.name !== "Register" &&
    to.name !== "ResetPassword" &&
    to.name !== "Instruction" &&
    !isAuthorized
  ) {
    next({ name: "Login" });
  } else if (
    (to.name === "Login" || to.name === "Register" || to.name === "Home") &&
    isAuthorized
  ) {
    next({ name: "BookmakerLeagues" });
  } else if (to.meta && to.meta.admin && !store.getters["user/isAdmin"]) {
    // twarda ochrona jest po stronie serwera; tutaj tylko chowamy ekran przed nie-adminem
    next({ name: "BookmakerLeagues" });
  } else next();
});

export default router;
